import { render, staticRenderFns } from "./SucVerticalTableComponent.vue?vue&type=template&id=84d217f6&scoped=true&"
import script from "./SucVerticalTableComponent.vue?vue&type=script&lang=js&"
export * from "./SucVerticalTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d217f6",
  null
  
)

export default component.exports